import { render, staticRenderFns } from "./sxqyResearcreport.vue?vue&type=template&id=a5daa928&scoped=true"
import script from "./sxqyResearcreport.vue?vue&type=script&lang=js"
export * from "./sxqyResearcreport.vue?vue&type=script&lang=js"
import style0 from "./sxqyResearcreport.vue?vue&type=style&index=0&id=a5daa928&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5daa928",
  null
  
)

export default component.exports